import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Button, Dropdown, Layout, Menu } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined, SearchOutlined } from "@ant-design/icons";
import Logo from "./Logo";
import { onMobileNavToggle, toggleCollapsedNav } from "redux/actions/Theme";
import { NAV_TYPE_TOP, SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH } from "constants/ThemeConstant";
import utils from "utils";
import { useFirebase } from "react-redux-firebase";
import { useTranslation } from "react-i18next";
import { LeadSearchModal } from "../shared-components/LeadSearchModal";

const { Header } = Layout;

export const HeaderNav = (props) => {
  const {
    navCollapsed,
    mobileNav,
    navType,
    headerNavColor,
    toggleCollapsedNav,
    onMobileNavToggle,
    isMobile,
    currentTheme,
  } = props;
  const firebase = useFirebase();
  const { t } = useTranslation();
  const [searchActive, setSearchActive] = useState(false);
  const authEmail = useSelector((state) => state.firebaseReducer.profile.email);
  const [leadSearchOpen, setLeadSearchOpen] = useState(false);

  const onSearchClose = () => {
    setSearchActive(false);
  };

  const onToggle = () => {
    if (!isMobile) {
      toggleCollapsedNav(!navCollapsed);
    } else {
      onMobileNavToggle(!mobileNav);
    }
  };

  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  const mode = () => {
    if (!headerNavColor) {
      return utils.getColorContrast(currentTheme === "dark" ? "#00000" : "#ffffff");
    }
    return utils.getColorContrast(headerNavColor);
  };
  const navMode = mode();
  const getNavWidth = () => {
    if (isNavTop || isMobile) {
      return "0px";
    }
    if (navCollapsed) {
      return `${SIDE_NAV_COLLAPSED_WIDTH}px`;
    } else {
      return `${SIDE_NAV_WIDTH}px`;
    }
  };

  const handleSignOut = (e) => {
    e.preventDefault();
    firebase.logout().catch((err) => console.log(err));
  };

  useEffect(() => {
    if (!isMobile) {
      onSearchClose();
    }
  });

  const accountMenu = (
    <Menu>
      <Menu.Item key="email" disabled>
        {authEmail}
      </Menu.Item>
      <Menu.Item
        key="logout"
        onClick={(info) => {
          handleSignOut(info.domEvent);
        }}
      >
        {t("logout")}
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Header className={`app-header ${navMode}`} style={{ backgroundColor: "white", paddingLeft: 0 }}>
        <div className={`app-header-wrapper ${isNavTop ? "layout-top-nav" : ""}`}>
          <Logo logoType={navMode} />
          <div className="nav" style={{ width: `calc(100% - ${getNavWidth()})` }}>
            <div className="nav-left">
              {isNavTop && !isMobile ? null : navCollapsed || isMobile ? (
                <MenuUnfoldOutlined
                  className="nav-icon"
                  onClick={() => {
                    onToggle();
                  }}
                />
              ) : (
                <MenuFoldOutlined
                  className="nav-icon"
                  onClick={() => {
                    onToggle();
                  }}
                />
              )}
            </div>
            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
              <Button icon={<SearchOutlined />} onClick={() => setLeadSearchOpen(true)}>
                Zoek lead
              </Button>
              <Dropdown overlay={accountMenu} trigger={["click"]} placement="bottomRight">
                <Button>Mijn account</Button>
              </Dropdown>
            </div>
          </div>
        </div>
      </Header>
      <LeadSearchModal open={leadSearchOpen} onClose={() => setLeadSearchOpen(false)} />
    </>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, headerNavColor, mobileNav, currentTheme } = theme;
  return {
    navCollapsed,
    navType,
    headerNavColor,
    mobileNav,
    currentTheme,
  };
};

export default connect(mapStateToProps, {
  toggleCollapsedNav,
  onMobileNavToggle,
})(HeaderNav);
